import { IPartnerAppSettings } from '../interface/IPartnerAppSettings';

export const aurorasit: IPartnerAppSettings = {
  flightingAppEnvironment: 'AuroraSIT',
  esxpBaseUrl: 'https://esxp-aurora-sit.microsoft.com/',
  cdnBaseUrl: 'https://gcmra-ui-uat-react-bwdmdaevc6aydfgq.b02.azurefd.net',
  serviceEndPoints: [
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint: 'https://oneprofileuatapipack.azurefd.net',
    },
    {
      clientId: '99b7fa0a-a125-4f7a-abea-efb429bb8972',
      serviceEndPoint:
        'https://preprod.apis.profileskills.microsoft.com/graphql',
    },
    {
      clientId: '6f40053e-5319-40e5-a90b-6f714506d96d',
      serviceEndPoint: 'https://esxp-aurora-sit.microsoft.com/rmavl',
    },
    {
      clientId: '38578c27-d821-45d3-95db-fcf0e8371e68',
      serviceEndPoint: 'https://grmetoeapiwus.azurewebsites.net',
    },
    {
      clientId: '38578c27-d821-45d3-95db-fcf0e8371e68',
      serviceEndPoint: 'https://esxp-aurora-sit.microsoft.com',
    },
    {
      clientId: '38578c27-d821-45d3-95db-fcf0e8371e68',
      serviceEndPoint: 'https://esxp-sit.microsoft.com',
    },
  ],
  AvailabilityBaseUrl: 'https://esxp-aurora-sit.microsoft.com/rmavl',
  GrmApiBaseUrl: 'https://grmetoeapiwus.azurewebsites.net',
  OpGraphQlUrl: 'https://preprod.apis.profileskills.microsoft.com/graphql',
  SearchServiceUrl:
    'https://esxp-sit.microsoft.com/api/v1/Search/grmaurorasit/grm-assignmentsearch-aurorasit-index',
};
